import { REVALIDATE_TIME } from "@shared/constants";
import { extractError, toCamel } from "@shared/utils";
import { NacoHandler, User } from "../types";

export function nacoHandler(accessToken?: string | null, refreshCallback?: any): NacoHandler {
  const refreshNaco = async () => {
    const response = await fetch("/api/naco/refresh", {
      method: "POST",
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const message = data?.message || (data.error ? extractError(data.error) : null) || response.statusText || "Unknown error";

      throw new Error(message);
    }

    return data.ok;
  }

  const getUser = async () => {
    if (accessToken) {
      const response = await fetch("https://account.kemnaker.go.id/api/v1/users/me", {
        method: "GET",
        cache: "no-store",
        next: { revalidate: REVALIDATE_TIME },
        headers: {
          "Authorization": `Bearer ${accessToken}`,
        }
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        const message = data?.message || (data.error ? extractError(data.error) : null) || response.statusText || "Unknown error";

        if (response.status === 401 || response.status === 500) {
          const refresh = await refreshNaco();

          if (refresh && refreshCallback && typeof refreshCallback === "function") {
            refreshCallback();
          }
        }

        throw new Error(message);
      }

      return toCamel(data.data) as User;
    }

    return null;
  }

  const nacoHeaders = {
    "Authorization": `Bearer ${accessToken}`,
    "naco-authentication": "1",
  };

  return {
    accessToken: accessToken,
    headers: nacoHeaders,
    refreshNaco,
    getUser,
  }
}